<template>
  <div style="position: relative; overflow: hidden; min-height: 300px">
    <template>
      <!-- <vue-aliplayer-v2 :ref="videoRef" :id="videoRef" :source="source" :options="options" /> -->
      <div
        id="dplayer"
        :ref="videoRef"
        v-show="isLive"
        :style="`height:${height}px`"
      ></div>
      <!-- :style="`height:${height}px`" -->
      <!-- <H265Player
      :url="videoUrl"
      style="height:15vw"
    /> -->
      <div ref="playMask" class="play-mask" v-show="isLive">
        <div v-show="showLoading" class="ring-1"></div>
        <div v-show="!showLoading">
          <p>获取播放源失败</p>
          <div class="error-operation">
            <a class="btn" @click="retry">重试</a>
          </div>
        </div>
      </div>
    </template>
    <div
      v-if="!isLive"
      :style="`position: absolute; width: 100%; height: ${height}px; color: #fff`"
      class="df aic jcc"
    >
      {{ playLimitMsg }}
    </div>
  </div>
</template>

<script>
import Hls from "hls.js";
import DPlayer from "dplayer";
// import VueAliplayerV2 from "vue-aliplayer-v2";
// import H265Player from 'vue-h265-player';
import api from "../../../../util/api";
import axios from "../../../../util/extra-api";
export default {
  //   components: {
  //   H265Player,
  // },
  //   components: { VueAliplayerV2: VueAliplayerV2.Player },
  props: {
    id: String,
    isFeedback: {
      type: Boolean,
      default: false,
    },
    companyId: {
      type: [Number, String],
      default: "",
    },
    camId: {
      type: [Number, String],
      default: "",
    },
    height: {
      type: [Number, String],
      default: 300,
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      videoRef: "",
      dPlayer: null,
      videoUrl: "",
      showLoading: true,
      value: 0,
      timer: null,
      isLive: true,
      playLimitMsg: "",
    };
  },
  watch: {
    isFeedback(newVal, oldVal) {
      // console.log(newVal,'isFeedback');
      if (newVal) {
        if (this.dPlayer && this.dPlayer.video) {
          let player = this.dPlayer.video;
          let canvas = document.createElement("canvas");
          canvas.width = player.clientWidth;
          canvas.height = player.clientHeight;
          canvas
            .getContext("2d")
            .drawImage(player, 0, 0, canvas.width, canvas.height);
          let dataURL = canvas.toDataURL("image/png");
          axios
            .post("/v1/wx/upload/base64Upload", {
              imgData: dataURL,
            })
            .then((res) => {
              this.$emit("screenshot", res.data);
            });
        } else {
          this.$emit("screenshot", null);
        }
      }
    },
  },
  computed: {},
  mounted() {
    this.videoRef = `player-${this.id}`;
    this.init();
  },
  methods: {
    initTimer() {
      // console.log("操作");
      axios
        .get("/v1/wx/monitor/pcCamLimit", {
          companyId: this.companyId,
          camId: this.camId,
        })
        .then((res) => {
          if (res.code == 200) {
            this.isLive = res.data.code;
            if (res.data.code) {
              this.timer = setTimeout(() => {
                this.initTimer();
              }, 180000);
            } else {
              this.playLimitMsg = res.data.msg;
            }
            console.log("播放接口请求成功", res);
          }
        });
    },
    destroyPlayer() {
      if (this.hls) {
        this.hls.destroy();
        this.hls = null;
      }
      if (this.dPlayer) {
        this.dPlayer.destroy();
        this.dPlayer = null;
      }
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    init() {
      api.get("/pc/company-cam/live", { id: this.id }).then((response) => {
        const data = response.data;
        this.videoUrl = data;
        const _this = this;
        this.dPlayer = new DPlayer({
          container: _this.$refs[_this.videoRef],
          live: true,
          mutex: false,
          screenshot: true,
          autoplay: this.autoplay,
          volume: 0,
          video: {
            url: _this.videoUrl,
            type: "customHls",
            customType: {
              customHls: function (video, player) {
                _this.hls = new Hls();
                _this.hls.loadSource(_this.videoUrl);
                _this.hls.attachMedia(video);
                _this.hls.on(Hls.Events.ERROR, function (event, data) {
                  switch (data.type) {
                    case Hls.ErrorTypes.NETWORK_ERROR:
                      let videoContent = _this.$refs[_this.videoRef];
                      let h =
                        videoContent.clientHeight || videoContent.offsetHeight;
                      let playMask = _this.$refs.playMask;
                      playMask.style.height = h + "px";
                      playMask.style.display = "block";
                      if (_this.value < 5) {
                        _this.hlsTryLoadTimer = setTimeout(
                          () => _this.hlsTryLoad(),
                          3000
                        );
                      } else {
                        _this.showLoading = false;
                      }
                  }
                });
                _this.hls.on(Hls.Events.MANIFEST_PARSED, function () {
                  _this.$refs.playMask.style.display = "none";
                });
              },
            },
          },
        });
        this.dPlayer.template.menu.remove();
        this.dPlayer.template.notice.remove();
        // setTimeout(() => {
        //   // console.log(this.dPlayer.video,123123);
        //   let player = this.dPlayer.video;
        //   var canvas = document.createElement("canvas");
        //   canvas.width = player.clientWidth;
        //   canvas.height = player.clientHeight;
        //   canvas
        //     .getContext("2d")
        //     .drawImage(player, 0, 0, canvas.width, canvas.height);
        //   var dataURL = canvas.toDataURL("image/png");
        // }, 6000);
        this.dPlayer.template.webFullButton.remove();
        let self = this;
        this.dPlayer.on("play", function () {
          if (this.companyId) {
            self.initTimer();
          }
          // console.log("play开始播放视频事件");
          // console.log(self.companyId, "companyId");
        });
        this.dPlayer.on("pause", function () {
          console.log("pause暂停视频事件");
          console.log(self.companyId, "companyId");
          self.clearTimeout();
        });
      });
      document.getElementById("dplayer").style.height = this.heihgt + "px";
    },

    hlsTryLoad() {
      this.hls.loadSource(this.videoUrl);
      this.hls.startLoad();
      this.value++;
    },
    retry() {
      if (this.id.includes("https")) {
        this.hlsTryLoad();
      } else {
        api.get("/pc/company-cam/live/" + this.id).then((response) => {
          const data = response.data;
          this.videoUrl = data;
          const _this = this;
          _this.showLoading = true;
          _this.value = 0;
          _this.hlsTryLoad();
        });
      }
    },
  },
  beforeDestroy() {
    this.hls.destroy();
    this.dPlayer.destroy();
  },
};
</script>
<style>
#dplayer {
  width: 100%;
  /* height: 300px; */
}
.play-mask {
  position: absolute;
  left: 0px;
  top: 0px;
  display: none;
  width: 100%;
  height: 100%;
  color: #fff;
  background-color: #000;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  z-index: 99;
  overflow: hidden;
  text-align: center;
}
.play-mask .error-operation {
  margin-top: 10px;
  margin-bottom: 10px;
  padding-bottom: 5px;
  border-bottom: 1.5px;
  border-bottom-color: rgba(255, 255, 255, 0.15);
  border-bottom-style: dotted;
  text-align: center;
}
.play-mask .error-operation .btn {
  width: 80px;
  height: 32px;
  line-height: 32px;
  vertical-align: top;
  display: inline-block;
  margin-left: 10px;
  text-decoration: none;
  color: #4b9cdb;
  border: solid 1px #4b9cdb;
  background-color: transparent;
  cursor: pointer;
}
.ring-1 {
  position: absolute;
  top: 40%;
  left: 45%;
  width: 10px;
  height: 10px;
  margin: 0 auto;
  padding: 10px;
  border: 3px dashed #4b9cdb;
  border-radius: 100%;
  animation: loadingD 1.5s 0.3s cubic-bezier(0.17, 0.37, 0.43, 0.67) infinite;
}
@keyframes loadingD {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
